import React from 'react'
import ContentLoader from 'react-content-loader'
import { withUserUnknown } from './shared/withKeycloak'
import CloseUserAreaButton from './shared/CloseUserAreaButton'

const UserAreaPlaceHolder = () => {
  return (
    <div>
      <CloseUserAreaButton />
      <ContentLoader
        speed={2}
        width={400}
        height={600}
        viewBox="0 0 400 600"
        backgroundColor="#e6e6e6"
        foregroundColor="#cdcdcd"
      >
        <rect x="163" y="144" rx="5" ry="5" width="88" height="15" />
        <rect x="72" y="198" rx="5" ry="5" width="137" height="13" />
        <rect x="36" y="179" rx="5" ry="5" width="343" height="1" />
        <circle cx="207" cy="82" r="44" />
        <rect x="36" y="236" rx="5" ry="5" width="343" height="1" />
        <rect x="36" y="293" rx="5" ry="5" width="343" height="1" />
        <circle cx="47" cy="264" r="9" />
        <rect x="38" y="198" rx="5" ry="5" width="19" height="19" />
        <rect x="36" y="349" rx="5" ry="5" width="343" height="1" />
        <rect x="72" y="255" rx="5" ry="5" width="106" height="13" />
        <circle cx="47" cy="321" r="9" />
        <rect x="72" y="312" rx="5" ry="5" width="191" height="13" />
      </ContentLoader>
    </div>
  )
}

export default withUserUnknown(UserAreaPlaceHolder)
